/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    name: 'login',
    path: '/login',
    component: import('@/views/auth/Login.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    name: 'logout',
    path: '/logout',
    component: import('@/views/auth/Login.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/forgot-pass',
    component: import('@/views/auth/ForgotPass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/create-pass',
    component: import('@/views/auth/CreatePass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/confirm-forgot-pass',
    component: import('@/views/auth/ConfirmForgotPass.vue'),
    meta: { layout: 'no-sidebar' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: import('@/views/dashboard/index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/site',
    name: 'Sites',
    component: import('@/views/site/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/account',
    name: 'Accounts',
    component: import('@/views/account/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/disposal',
    name: 'Disposal Centers',
    component: import('@/views/disposal/Index.vue'),
    meta: { layout: 'default' }
  },
  // {
  //   path: '/drug',
  //   name: 'Drugs',
  //   component: import('@/views/drug/Index.vue'),
  //   meta: { layout: 'default' }
  // },
  {
    path: '/pharmacy',
    name: 'Pharmacies',
    component: import('@/views/pharmacy/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/provider',
    name: 'Providers',
    component: import('@/views/provider/Index.vue'),
    meta: { layout: 'default' }
  },

  {
    path: '/storage',
    name: 'Storage',
    component: import('@/views/storage/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol',
    name: 'Protocols',
    component: import('@/views/protocol/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol/:id',
    name: 'Edit Protocol',
    component: import('@/views/protocol/Edit.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol/:protocolId/drugs',
    name: 'Protocol Drugs',
    component: import('@/views/drug/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol/:protocolId/sites',
    name: 'Protocol Sites',
    component: import('@/views/protocol_has_site/Index.vue'),
    meta: { layout: 'default' }
  },  
  {
    path: '/protocol/:protocolId/request',
    name: 'Requests',
    component: import('@/views/request/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/protocol/:protocolId/request/new',
    name: 'New Request',
    component: import('@/views/request/New.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/request/:requestId',
    name: 'View Request',
    component: import('@/views/request/Upsert.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/request',
    name: 'Request List',
    component: import('@/views/request/List.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/siterequest/new',
    name: 'New Site Request',
    component: import('@/views/siterequest/New.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/siterequest/:siterequestId',
    name: 'Site Request Detail',
    component: import('@/views/siterequest/Upsert.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/siterequest',
    name: 'Site Request',
    component: import('@/views/siterequest/Index.vue'),
    meta: { layout: 'default' }
  },  
  {
    path: '/siteresponse/:siterequestId/:token',
    name: 'Site Response',
    component: import('@/views/siterequest/Response.vue'),
    meta: { layout: 'token-auth' }
  },
  {
    path: '/fullyused/new',
    name: 'Fully Used',
    component: import('@/views/fully_used/New.vue'),
    meta: { layout: 'default' }
  },  
  {
    path: '/fullyused/:fullyusedId',
    name: 'Fully Used Detail',
    component: import('@/views/fully_used/Upsert.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/fullyused',
    name: 'Fully Used List',
    component: import('@/views/fully_used/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/returned/new',
    name: 'New Return Request',
    component: import('@/views/returned/New.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/returned/:returnedId',
    name: 'Check Returned Request',
    component: import('@/views/returned/Upsert.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/returned',
    name: 'Return',
    component: import('@/views/returned/Index.vue'),
    meta: { layout: 'default' }
  },  
  {
    path: '/disposed/new',
    name: 'Destroy Request',
    component: import('@/views/disposed/New.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/disposed/:disposedId',
    name: 'Destroy Request Details',
    component: import('@/views/disposed/Upsert.vue'),
    meta: { layout: 'default' }
  },  
  {
    path: '/disposed',
    name: 'Destroy List',
    component: import('@/views/disposed/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/report/available',
    name: 'Report Available',
    component: import('@/views/report/Stock.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/report/xls',
    name: 'Report XLS',
    component: import('@/views/report/XLS.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/movements',
    name: 'Movements',
    component: import('@/views/movements/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/movements/new',
    name: 'Patch',
    component: import('@/views/movements/NewPatch.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/patch/:patch_id',
    name: 'Movements Patch',
    component: import('@/views/movements/Patch.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/balance',
    name: 'Balance',
    component: import('@/views/movements/Balance.vue'),
    meta: { layout: 'default' }
  },  
  {
    path: '/balance/:drug_id/:lotto/:site_id',
    name: 'Balance Detail',
    component: import('@/views/movements/Balance.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/estimates',
    name: 'Estimate',
    component: import('@/views/estimate/Index.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/estimate/:estimate_id',
    name: 'Edit Estimate',
    component: import('@/views/estimate/Upsert.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/estimate',
    name: 'New Estimate',
    component: import('@/views/estimate/Upsert.vue'),
    meta: { layout: 'default', action: 'new' }
  },
  {
    path: '/utils',
    name: 'Utils',
    component: import('@/views/utils/Index.vue'),
    meta: { layout: 'default' }
  },
    {
    path: '/lost/new',
    name: 'Lost Create',
    component: import('@/views/lost/New.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/lost/:lostId',
    name: 'Lost Details',
    component: import('@/views/lost/Upsert.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/lost',
    name: 'Lost List',
    component: import('@/views/lost/Index.vue'),
    meta: { layout: 'default' }
  },
]
